import React from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Dialog } from "@/uiKit/atoms/Dialog.tsx";
import { NurseInclusionHistoryCard } from "@/uiKit/organisms/NurseInclusionHistoryCard.tsx";

export type NurseInclusionHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  className?: string;
};

export const NurseInclusionHistoryModal: React.FC<NurseInclusionHistoryModalProps> = ({ open, onClose, className }) => {
  const styles = useStyles(makeStyles);

  return (
    <Dialog
      id="nurse-inclusion-history-modal"
      open={open}
      onClose={onClose}
      maxWidth={1350}
      className={cx(styles.root, className)}
    >
      <NurseInclusionHistoryCard onClose={onClose} />
    </Dialog>
  );
};

const makeStyles = () => ({
  root: css({}),
});
